import React, { FC, useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import powerCurve from "../../../../../assets/images/powerCurve.png";
import PowerCurve from "./PowerCurve";
import { useAppSelector } from "../../../../../store/hooks/StoreHooks";
import { createChart3 } from "../../../../../utilities/commonUtilities";

interface Props { }

const PowerCurves: FC<Props> = () => {
  const powerChartRef = useRef<HTMLDivElement | null>(null);
  const [chart3Config, setChart3Config] = useState<any>([]);
  const { Chart3Data } = useAppSelector(state => state?.pump);
  const { isReports } = useAppSelector((state) => state?.reports);

  useEffect(() => {
    if (Chart3Data?.length > 0) {
      setChart3Config(createChart3(Chart3Data));
    }
  }, [Chart3Data]);

  const efficiencyChartDownload = () => {
    if (powerChartRef.current) {
      html2canvas(powerChartRef.current, {
        backgroundColor: "#384252",
      }).then((canvas) => {
        const imgUrl = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = imgUrl;
        link.download = "Power-Curves.png";
        link.click();
      });
    }
  };

  return (
    <>
      {" "}
      <div className="flex justify-between mt-[16px] p-4">
        <div></div>
        {!isReports && <div className="flex">
          <button
            onClick={efficiencyChartDownload}
            className="ml-[16px] border-[1px] border-solid border-[#4A5463] py-[8px] px-[14px] inline-flex justify-center items-center gap-[8px] rounded-[8px] bg-transparent text-neutral-25"
          >
            Export power curve
          </button>
        </div>}
      </div>
      <div className="mb-[15px] pt-[30px]" ref={powerChartRef}>
        <PowerCurve chart3Data={chart3Config} />
      </div>
    </>
  );
};

export default PowerCurves;
